// Notes:
// When run this react app locally, we can use the environment variables to configure the app, it must be prefixed with REACT_APP_
// Another way is config .env file in the root directory, and use the environment variables in the .env file.

// When it get build, .env file is used as well but code "process.env.REACT_APP_VERSION" is replaced with the actual version.
// So in .env, I can have some production variables.

/**
 * 将环境变量转换为布尔值
 * @param {string} envVar - 环境变量值
 * @param {boolean} defaultValue - 默认值（当环境变量未设置时）
 * @returns {boolean} 布尔值
 */
function toBoolean(envVar, defaultValue = true) {
  if (envVar === undefined) return defaultValue
  // Lowercase the value
  return envVar.toLowerCase() === 'true' || envVar === '1'
}

// App config that inject by server
const appConfig = window.__APP_CONFIG__ || {}

// Local config load from environment directly. Only works in local development.
const localConfig = {
  CHAT_ENABLED: process.env.REACT_APP_CLIENT_CHAT_ENABLED,
  GOOGLE_AUTH_CLIENT_ID: process.env.REACT_APP_CLIENT_GOOGLE_AUTH_CLIENT_ID,
  WEBSOCKET_URL: process.env.REACT_APP_CLIENT_WS_URL,
  APP_MODE: process.env.REACT_APP_MODE || 'production',
  APP_VERSION: process.env.REACT_APP_VERSION,
}

const mergedConfig = {
  ...localConfig,
  ...appConfig,
}

const isDev = mergedConfig.APP_MODE === 'development' || mergedConfig.APP_MODE === 'dev'
// const isDev = false

const config = {
  ...mergedConfig,
  IS_DEV: isDev,
  IS_PROD: !isDev,
  APP_VERSION: mergedConfig.APP_VERSION,
  GOOGLE_AUTH_CLIENT_ID: mergedConfig.GOOGLE_AUTH_CLIENT_ID,
  WEBSOCKET_URL: mergedConfig.WEBSOCKET_URL,
  CHAT_ENABLED: toBoolean(mergedConfig.CHAT_ENABLED),
}

export default config
